module.exports = __webpack_public_path__ + "assets/img/32_618.5b51963f.jpg";